import React, { useState, useCallback } from 'react';
import { tutorialStructure, tipData, t, initialLang } from '../types';
import TutorialCarousel from "../components/TutorialCarousel";
import TipItem from "../components/TipItem";
import TutorialModal from "../components/TutorialModal";
import "../App.css";

const App: React.FC = () => {
  const [currentLang, setCurrentLang] = useState(initialLang);
  const [selectedTutorialKey, setSelectedTutorialKey] = useState<string | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const openModal = useCallback((key: string) => {
    setSelectedTutorialKey(key);
  }, []);

  const closeModal = useCallback(() => {
    setSelectedTutorialKey(null);
  }, []);

  const changeLanguage = (lng: string) => {
    setCurrentLang(lng);
  };

  const localT = (key: string) => t(key, currentLang);

  return (
    <div id="app-root">
      <div className="app-container">
        {/* Language Switcher - Fixed Position */}
        <div className="lang-switcher">
          <button 
            onClick={() => changeLanguage('pt')} 
            className={currentLang === 'pt' ? 'active' : ''}
            title="Português"
          >
            <img src="/img/ptbr.gif" alt="PT" />
          </button>
          <button 
            onClick={() => changeLanguage('en')} 
            className={currentLang === 'en' ? 'active' : ''}
            title="English"
          >
            <img src="/img/ukus.gif" alt="EN" />
          </button>
        </div>

        {/* 1. CABEÇALHO (HEADER) */}
        <header className="header">
          <div className="header-logo-group">
            <div className="header-logo"></div>
            <h1 className="header-title"><img src='/img/stacking.gif' alt="Stacking"/></h1>
          </div>
          
          <button 
            className="mobile-menu-button" 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            <span className={`menu-icon ${isMenuOpen ? 'open' : ''}`}></span>
          </button>
          
          <nav className={`header-nav ${isMenuOpen ? 'mobile-open' : ''}`}>
            <ul>
              <li><a href="#home" className="font-pixel" onClick={() => setIsMenuOpen(false)}>Inicio</a></li>
              <li><a href="https://discord.gg/enBMUxzN9n" className="font-pixel" onClick={() => setIsMenuOpen(false)}>Discord</a></li>
              <li><a href="https://habbold.org" className="font-pixel" onClick={() => setIsMenuOpen(false)}>Habbold</a></li>
            </ul>
          </nav>
        </header>

        {/* 2. SEÇÃO PRINCIPAL (HERO) */}
        <section id="home" className="hero-section">
          <div className="hero-content">
            <div className="hero-text-block">
            </div>
            
            <div className="hero-image-placeholder">
              <span className="text-sm">
                {/* Placeholder para imagem */}
              </span>
            </div>
          </div>
        </section>

        {/* 3. TUTORIAIS EM DESTAQUE */}
        <section id="tutoriais" className="tutorials-section">
          <h3 className="section-title">{localT('app.section.tutorials')}</h3>
          
          <TutorialCarousel 
            tutorials={tutorialStructure}
            openModal={openModal}
            currentLang={currentLang}
            t={t}
          />
        </section>
        
        {/* 4. SEÇÃO DE DICAS E TRUQUES */}
        <section id="dicas" className="tips-section">
          <h3 className="section-title">{localT('app.section.tips')}</h3>
          
          <div className="flex-container">
            {tipData.map((data) => (
              <TipItem 
                key={data.key} 
                data={data} 
                currentLang={currentLang} 
                t={t}
              />
            ))}
          </div>
        </section>

        {/* 5. RODAPÉ (FOOTER) */}
        <footer className="footer">
          <p>{localT('footer.text')}</p>
        </footer>
      </div>

      {/* MODAL DE DETALHES DO TUTORIAL */}
      <TutorialModal 
        selectedTutorialKey={selectedTutorialKey} 
        closeModal={closeModal} 
        currentLang={currentLang}
      />
    </div>
  );
};

export default App;